import { render, staticRenderFns } from "./SettingsComissions.vue?vue&type=template&id=7c4330fe&scoped=true&"
import script from "./SettingsComissions.vue?vue&type=script&lang=js&"
export * from "./SettingsComissions.vue?vue&type=script&lang=js&"
import style0 from "./SettingsComissions.vue?vue&type=style&index=0&id=7c4330fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4330fe",
  null
  
)

export default component.exports